import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { mobilePromotion, promotions } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobilePromotion} w="100%" alt="Promotions" mt="-1px" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center>
          <CFImage src={promotions} w="75%" alt="Promotions" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
